<template>
  <div class="vantagens">
    <div v-for="(partner,index) in partners" in class="parceiro" v-bind:key="index">
      <router-link :to="{ name: 'vantagens-detalhe', params: {slug: partner.slug }}" :title="partner.title">
        <div v-bind:style="{ backgroundImage: 'url(' + (partner.banner ? partner.banner.imageUrl : '') + ')' }" class="partner-image">
        </div>
        <span class="title">{{ partner.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vantagensShowcase',
  created(){
    console.log(this.partners)
  },
  props: {
    partners: {
      type: Array
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/vantagensShowcase.scss";
</style>
